<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Advanced Credentials</h1>
                    <span>{{ softwarecertificatesCustomFields.length > 0 ? softwarecertificatesCustomFields[0].label
                    :
                    '' }}</span>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>    
            <el-form class="full_page" :label-position="'top'"
                @submit.prevent="goNext('userForm', nextPage ? true : false)">
                <template v-if="!nextPage">

                    <el-form-item prop="schedule" class="job_filters_form_checkbox">
                        <div class="item-select__header">
                            <div class="item-select__title">Experience</div>
                        </div>
                        <template v-if="softwarecertificatesCustomFields.length > 0">
                            <template v-for="(field, index) in softwarecertificatesCustomFields" :key="index">
                                <template v-if="field.fieldType === 'MultiSelectcheckboxWithFileUpload'">
                                    <el-checkbox-group v-model="form.selectedValues">
                                        <div v-for="(value, i) in field.values" :key="i">
                                            <el-checkbox :label="value.label"
                                                @change="handleCheckboxChange(value, index)">{{
                    value.label }}</el-checkbox>
                                            <el-input v-if="isDynamicSelected(value)" v-model="form[value.label]"
                                                :placeholder="`Enter ${value.label}`"></el-input>
                                        </div>
                                    </el-checkbox-group>
                                </template>
                                <el-form-item-error v-if="v$.selectedValues.$error">{{ v$.selectedValues.$errors[0].$message
                                    }}</el-form-item-error>
                            </template>
                        </template>
                    </el-form-item>
                    <el-button class="submit" :disabled="isDisabledNext" type="blue" @click="nextStep">
                        Next
                    </el-button>
                </template>
                <template v-else>
                    <div>
                        <div v-for="(selectedValue, index) in form.selectedValues" :key="index">
                            <div class="upload-label">
                                <div>{{ selectedValue }}</div>
                                <span class="remove-icon" @click.stop="removeSelectedValue(index)">
                                    <i class="el-icon-close"></i>
                            </span>
                            </div> <!-- Display the selected value as title -->
                            
                            
                            <!-- Render el-upload component for each selected value -->
                            <el-form-item :show-message="false" label="">
                                <el-upload class="uploader-support" :action="'upload'"
                                    :v-model:file-list="getFileList(selectedValue)" :name="getFileList(selectedValue)"
                                    list-type="picture" :thumbnail-mode="true" :limit="1"
                                    :on-preview="(selectedValue, file) => cropperOtherMethods.handlePreview(selectedValue, file)"
                                    :on-exceed="(selectedValue, file, files) => cropperOtherMethods.handleExceed(selectedValue, file, files)"
                                    :drag="true"
                                    :on-change="(file, fileList) => cropperOtherMethods.handleChange(selectedValue, file, fileList)"
                                    :before-upload="(selectedValue, file) => cropperOtherMethods.beforeAvatarUpload(selectedValue, file)">
                                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M27 4.5V18L31.5 13.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M27 18L22.5 13.5" stroke="black" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M15.75 27C6.75 27 6.75 31.0275 6.75 36V38.25C6.75 44.46 6.75 49.5 18 49.5H36C45 49.5 47.25 44.46 47.25 38.25V36C47.25 31.0275 47.25 27 38.25 27C36 27 35.37 27.4725 34.2 28.35L31.905 30.78C29.25 33.615 24.75 33.615 22.0725 30.78L19.8 28.35C18.63 27.4725 18 27 15.75 27Z"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.25 26.9998V17.9998C11.25 13.4773 11.25 9.74234 18 9.08984"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M42.75 26.9998V17.9998C42.75 13.4773 42.75 9.74234 36 9.08984"
                                    stroke="black" stroke-width="2" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div class="cv-upload-title">Browse Your Files</div>
                            <div class="cv-upload-info">You can upload file with PDF, JPEG or PNG formats.</div>
                                    <template #file="{ file }">
                                        <div class="wrap-fd"
                                                style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                                <div v-if="file.raw.type == 'application/pdf'"
                                                    class="el-upload-list__item-body">
                                                    <!-- <span class="locumate_icons locumate_icon-picture"></span> -->
                                                    
                                                    <img class="el-upload-list__item-body-thumbnail"
                                                        :src="require('@/assets/img/icons/pdf.svg')" />
                                                        <span class="mx-2" size="large">{{ file.name }}</span>
                                                </div>
                                                <div class="el-upload-list__item-body" v-else>
                                                    <img class="el-upload-list__item-thumbnail" :src="file.url"
                                                        alt="" />
                                                        <span class="mx-2" size="large">{{ file.name }}</span>
                                                </div>
                                                <!-- Remove Button -->
                                                <div class="el-upload-list__item-actions">
                                                    <button class="el-upload-list__item-actions-action"
                                                        @click.prevent="cropperOtherMethods.handleRemove(selectedValue, file)">
                                                        <img :src="require('@/assets/img/icons/trash.svg')" />
                                                    </button>
                                                </div>
                                            </div>
                                    </template>
                                </el-upload>

                                <!-- <el-form-item-error v-if="v$.otherFiles.$error">{{ v$.otherFiles.$errors[0].$message
                            }}</el-form-item-error> -->
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item class="button_submit mb0">
                        <el-button :disabled="isSubmitDisabled" class="submit_page submit" type="blue" @click="goNext('userForm')">
                            Continue 
                        </el-button>
                    </el-form-item>
                </template>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
    onBeforeMount,
    ref,
    reactive,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import FileHelpers from "@/helpers/file/file";
import { ElMessage } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    directives: {
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const fileHelpers = new FileHelpers();
        const userData = $store.getters.GET_USER_DATA;
        const softwarecertificatesCustomFields = ref([]);
        console.log("🚀 ~ setup ~ customFields:", softwarecertificatesCustomFields)
        console.log($store.getters.getJobFilters.schedule);
        let nextPage = ref(false);
        const form = reactive({
            selectedValues: ref([]),


        });

        const rules = computed(() => {
            return {
                selectedValues: { required: helpers.withMessage('Please select certification', required) },
            };
        });
        const v$ = useVuelidate(rules, form);


        const isDynamicSelected = (value) => {
            return (
                form.selectedValues.includes(value.label) && value.showTextbox === true
            );
        };


        const getUploadName = (selectedValue) => {
            const formattedName = selectedValue.toLowerCase().replace(/\s/g, "_");
            return `${formattedName}_upload`;
        };

        const getFileList = (selectedValue) => {
            const formattedName = selectedValue.toLowerCase().replace(/\s/g, "_");
            const main = `${formattedName}_upload`;
            console.log("🚀 ~ getFileList ~ main:", main)
            return computed(() => main);

        };

        const goNext = async () => {
            const result = await v$.value.$validate();
            if(form.selectedValues.length === 0){
              
                $router.push({
                    name: "jobseeker_auth_cv"
                })
                
                return;
            }
            if (!result) {
                alert('The form has errors');
                return;
            } else {
                for (const selectedValue of form.selectedValues) {
                    const formData = new FormData();
                    const otherValue = form[selectedValue] ? form[selectedValue] : "";
                    const fileKey = getUploadName(selectedValue);
                    // If file exists, append file to FormData
                    const files = form[fileKey];
                    console.log("🚀 ~ goNext ~ files:", files)
                    formData.append('key', 'certificates');
                    formData.append(`values`, JSON.stringify({ value: selectedValue, other_value: otherValue, file: true }));
                    if (files && files.length > 0) {
                        files.forEach((file) => {
                            formData.append(`file`, file.raw); // Assuming file is already a File object

                        });
                    }
                    try {
                        await $store.dispatch("SAVE_USER_CERFICATIONS_DATA", formData);
                        if(userData.platformRoleSlug == 'intern-pharmacist'){
                            $router.push({
                                name: 'jobseeker_auth_university',
                            })
                        }else{
                            $router.push({
                                name: 'jobseeker_auth_cv',
                            })
                        }
                        
                    } catch (error) {
                        console.log(error);
                    }

                }



            }
        };

        const skip = () => {
            (async () => {
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    if(userData.platformRoleSlug == 'intern-pharmacist'){
                        $router.push({
                            name: 'jobseeker_auth_university',
                        })
                    }else{
                        $router.push({
                            name: 'jobseeker_auth_cv',
                        })
                    }
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_pharmacy_experience_page');

        });

        onBeforeMount(async () => {
            try {
                const response = await $store.dispatch("GET_CUSTOM_FIELDS",);
                console.log("🚀 ~ onBeforeMount ~ check:", response)
                softwarecertificatesCustomFields.value = response.data.certificates;
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });

        const handleCheckboxChange = (value, index) => {
            console.log("🚀 ~ handleCheckboxChange ~ index:", index)
            console.log("🚀 ~ handleCheckboxChange ~ value:", value.label)
            // If the "Speciality" checkbox is checked, show the input field
            if (form.selectedValues.includes(value.label)) {
                const transformedString = value.label.toLowerCase().replace(/\s/g, "_");
                const ruleUploadKey = transformedString + '_upload';
                rules.value[ruleUploadKey] = { required };

                // Add the otherInputValue[index] field to the form
                const fieldValue = ref([]);
                form[ruleUploadKey] = ref(fieldValue);

                // Touch the field to trigger validation
                v$.value.$touch(ruleUploadKey);
            } else {
                console.log('on ssssssssssremoveeeeee', value.label);
                const transformedString = value.label.toLowerCase().replace(/\s/g, "_");
                const ruleUploadKey = transformedString + '_upload';
                delete rules.value[ruleUploadKey];
                delete form[ruleUploadKey];
            }

            if (value.showTextbox && form.selectedValues.includes(value.label)) {
                const ruleKey = value.label;
                rules.value[ruleKey] = { required };

                // Add the otherInputValue[index] field to the form
                const fieldValue = "";
                form[ruleKey] = ref(fieldValue);

                // Touch the field to trigger validation
                v$.value.$touch(ruleKey);
            } else {
                console.log('on removeeeeee', value.label)
                const ruleKey = value.label;
                delete rules.value[ruleKey];
                delete form[ruleKey];
            }
        };


        const isSubmitDisabled = computed(() => {
            if(form.selectedValues.length === 0){
               return false;
            }
            return Object.values(form).some(value => value.length == 0) || v$.value.$pending || v$.value.$error;
        });

        const isDisabledNext = computed(() => {
            return form.selectedValues.length == 0;
        });

        const nextStep = () => {
            nextPage.value = !nextPage.value;
        };
        const goBack = async() => {
            if (nextPage.value) {
                nextPage.value = !nextPage.value;
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });
            }
        };

        const cropperOtherMethods = {
            beforeAvatarUpload(file) {
                console.log("🚀 ~ beforeAvatarUpload ~ file:", file)
                const image = URL.createObjectURL(file.raw);
                console.log("🚀 ~ beforeAvatarUpload ~ image:", image)
                // const maxSize = 10 * 1024 * 1024; // 10 MB (adjust as needed)
                // if (file.size > maxSize) {
                //     ElMessage({
                //         type: "error",
                //         message: `File size must be less then 10MB! `,
                //     });
                 
                // }
            },
            handleRemove(selectedValue, file) {
                console.log("Selected value:", selectedValue);
                const modelName = getFileList(selectedValue);
                form[modelName.value].splice(form[modelName.value].indexOf(file), 1);
            },
            handleChange(selectedValue, file, fileList) {
                console.log("🚀 ~ file:", file)
                console.log("Selected value:", selectedValue);
                const type = fileHelpers.getFileType(file);
                const modelName = getFileList(selectedValue);
                console.log("🚀 ~ handleChange ~ modelName:", modelName)
                console.log("🚀 ~ modelName:", modelName.value)
                if (type == "image" || type == "pdf") {
                    form[modelName.value] = fileList;
                    console.log("Selected value fileList:", form[modelName]);
                } else {
                    fileList.pop();
                    form[modelName.value] = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
            },
            handlePreview(selectedValue, file) {
                console.log("🚀 ~ file:", file)
                console.log("Selected value:", selectedValue);
                // Handle preview logic here
            },
            handleExceed(selectedValue, file, files) {
                console.log("🚀 ~ handleExceed ~ files:", files)
                console.log("🚀 ~ handleExceed ~ file:", file)
                console.log("Selected value:", selectedValue);
                ElMessage({
                    type: "error",
                    message: `You can upload 1 document, you selected ${selectedValue.length} `,
                });
            },
        };

        const removeSelectedValue = (index) => {
            const value = form.selectedValues[index];
            console.log("🚀 ~ removeSelectedValue ~ value:", value)
            console.log("🚀 ~ removeSelectedValue ~ index:", index)
            form.selectedValues.splice(index, 1);

            const fieldName = value.toLowerCase().replace(/\s/g, '_') + '_upload';
            console.log("🚀 ~ removeSelectedValue ~ fieldName:", fieldName)
            if (form[fieldName] !== undefined) {
                delete form[fieldName];
            }
        };


        return {
            goBack,
            goNext,
            handleCheckboxChange,
            isDynamicSelected,
            softwarecertificatesCustomFields,
            form,
            rules,
            v$,
            validateField,
            isSubmitDisabled,
            nextStep,
            nextPage,
            isDisabledNext,
            getUploadName,
            getFileList,
            cropperOtherMethods,
            removeSelectedValue,
            skip,
            userData
        }
    },
}
</script>
